import styled from 'styled-components';

export const Container = styled.div`
  button.databalloon[aria-label] {
    overflow: visible;
  }
`;
